import { createContext, useContext } from "react";
import { useStoreWithEqualityFn } from "zustand/traditional";

import type { FeatureIslandCategoryStore, FeatureIslandCategoryStoreType } from "../store";

export const FeatureIslandCategoryContext = createContext<FeatureIslandCategoryStore | null>(null);

export const useFeatureIslandCategoryContext = <T>(
	selector: (state: FeatureIslandCategoryStoreType) => T,
	equalityFn?: (left: T, right: T) => boolean,
) => {
	const featureIslandCategory = useContext(FeatureIslandCategoryContext);

	if (!featureIslandCategory) {
		throw new Error("FeatureIslandCategoryContext is not defined");
	}

	return useStoreWithEqualityFn(featureIslandCategory, selector, equalityFn);
};
